import grid from './extensions/ext-grid/ext-grid.js';
import opensave from './extensions/ext-opensave/ext-opensave.js';
import overviewWindow from './extensions/ext-overview_window/ext-overview_window.js';

export const builtInExtensions = [
    grid,
    overviewWindow,
    opensave,
];
